import { useEffect, useState } from "react";
import {
  AdesaoCard,
  HeaderCollum,
  HeaderRow,
  LeftContent,
  RightContent,
  SesiImage,
  ValidationStyle,
  ValidationTitle,
  WrapAdesao,
  WrapContent,
  SelectionIndicator,
  WrapTitleAndButtons,
  DenyButton,
  AcceptButton,
  WrapButtons,
  BackButton,
  SelectAllButton,
  Select,
} from "../../styles/Validation";
import SESI from "../../assets/img/sesi.png";
import { useNavigate } from "react-router-dom";
import { HOME_LOGGED } from "../../core/app-urls";
import ChangedPlanModel from "../../data/models/changedPlan";
import { getListOfChangedPlans } from "../../data/services/enterprise_service";
import { acceptChangePlanInvite } from "../../data/provider/enterprise/api_enterprise";
import { getContractsPF } from "../../data/services/person_service";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function PlanChangeValidation() {
  const [selectedCards, setSelectedCards] = useState<number[]>([]);
  const [changedPlans, setChangedPlans] = useState<ChangedPlanModel[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [selectedContractId, setSelectedContractId] = useState<string>("");
  const [contracts, setContracts] = useState<any[]>([]);
  const [processing, setProcessing] = useState<boolean>(false);

  const navigate = useNavigate();

  useEffect(() => {
    fetchContracts();
  }, []);

  const fetchContracts = async () => {
    setLoading(true);
    const response = await getContractsPF();
    if (response.data) {
      setContracts(response.data);
    } else {
      console.error("Não foi possível carregar os contratos.");
    }
    setLoading(false);
  };

  const fetchChangedPlans = async (contractId: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await getListOfChangedPlans(contractId);
      if (response.data) {
        setChangedPlans(response.data);
      } else {
        setError("Nenhum dado encontrado.");
        setChangedPlans([]);
      }
    } catch (err) {
      setError("Erro ao buscar alterações de planos.");
      setChangedPlans([]);
    } finally {
      setLoading(false);
    }
  };

  const toggleSelection = (id: number) => {
    setSelectedCards((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleAcceptOrDeny = async (accept: string) => {
    if (selectedCards.length === 0) {
      toast.warning("Selecione pelo menos uma alteração de plano.");
      return;
    }

    try {
      setProcessing(true);

      await acceptChangePlanInvite(selectedCards, accept);

      if (accept === "S") {
        toast.success("Alterações de plano aprovadas com sucesso!");
      } else {
        toast.success("Alterações de plano reprovadas com sucesso!");
      }

      setSelectedCards([]);

      if (selectedContractId) {
        fetchChangedPlans(selectedContractId);
      }
    } catch (error) {
      toast.error("Erro ao processar alterações de plano.");
    } finally {
      setProcessing(false);
    }
  };

  const toggleSelectAll = () => {
    if (selectedCards.length === changedPlans.length) {
      setSelectedCards([]);
    } else {
      setSelectedCards(changedPlans.map((plan) => plan.id));
    }
  };

  const handleLogout = () => {
    navigate(HOME_LOGGED);
  };

  return (
    <ValidationStyle>
      <ToastContainer />
      <WrapContent>
        <BackButton onClick={handleLogout}>VOLTAR</BackButton>
        <HeaderRow>
          <SesiImage src={SESI} />
          <HeaderCollum>
            <h1>Olá, {localStorage.getItem("name")}</h1>
            <h2>Seja bem-vindo(a) ao PORTAL DO CLIENTE</h2>
          </HeaderCollum>
        </HeaderRow>
        <WrapTitleAndButtons>
          <ValidationTitle>Validação de planos</ValidationTitle>
          <Select
            value={selectedContractId}
            onChange={(e) => {
              const contractId = e.target.value;
              setSelectedContractId(contractId);
              if (contractId) {
                fetchChangedPlans(contractId);
              } else {
                setChangedPlans([]);
              }
            }}
          >
            <option value="">Selecione o número do contrato</option>
            {contracts.map((contract) => (
              <option key={contract.idContrato} value={contract.idContrato}>
                {contract.numero_contrato}
              </option>
            ))}
          </Select>
          <SelectAllButton onClick={toggleSelectAll}>
            {selectedCards.length === changedPlans.length
              ? "Desmarcar todos"
              : "Selecionar todos"}
          </SelectAllButton>
          <WrapButtons>
            <DenyButton
              disabled={processing}
              onClick={() => handleAcceptOrDeny("N")}
            >
              {processing ? "Processando..." : "Reprovar"}
            </DenyButton>

            <AcceptButton
              disabled={processing}
              onClick={() => handleAcceptOrDeny("S")}
            >
              {processing ? "Processando..." : "Aprovar"}
            </AcceptButton>
          </WrapButtons>
        </WrapTitleAndButtons>
        {loading ? (
          <p>Carregando alterações...</p>
        ) : error ? (
          <p>{error}</p>
        ) : (
          <WrapAdesao>
            {changedPlans.map((plan) => (
              <AdesaoCard
                key={plan.id}
                onClick={() => toggleSelection(plan.id)}
              >
                <LeftContent>
                  <h2>Número do contrato: {plan.num_contrato}</h2>
                  <h2>Nome: {plan.nome}</h2>
                  <h2>CPF: {plan.cpf}</h2>
                  <h2>Plano atual: {plan.planoAtual}</h2>
                  <h2>Novo plano: {plan.planoNovo}</h2>
                </LeftContent>
                <RightContent>
                  <SelectionIndicator
                    selected={selectedCards.includes(plan.id)}
                  />
                </RightContent>
              </AdesaoCard>
            ))}
          </WrapAdesao>
        )}
      </WrapContent>
    </ValidationStyle>
  );
}
